import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { useField } from 'react-final-form';
import ConfigContext from '../../../contexts/ConfigContext';
import { getRichTextVisibleLength, normalizeMarkdownValue } from '../../RichTextEditor/markdownUtils';
import { SmallBody } from '../../Typography';
import RichTextEditor from '../../RichTextEditor';
import { EditableByAdmins } from './EditableByAdmins';

const Wrapper = styled.div.attrs(() => ({ className: 'full' }))``;

const Label = styled(SmallBody).attrs(() => ({ className: 'description-field-label' }))`
  font-weight: normal;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 4px;
`;

const MaxLengthLabel = styled(SmallBody)`
  font-size: 12px;
  color: ${({ theme, $hasExceededLimit }) => ($hasExceededLimit ? 'lightcoral' : theme.colors?.grey4 || '#858585')};
  margin-top: 4px;
  text-align: right;
`;

const DescriptionFieldForm = ({
  placeholder,
  name = 'metadata.text',
  autoFocus = true,
  className = '',
  label = '',
  maxLength = undefined,
  showLimitEditAdminsToggle = false
}) => {
  const {
    input: { value = '', onChange }
  } = useField(name);
  const visibleLength = maxLength ? getRichTextVisibleLength(value) : 0;

  const { isRtl, t } = useContext(ConfigContext);

  const handleChange = useCallback(
    (markdown) => {
      onChange(normalizeMarkdownValue(markdown));
    },
    [onChange]
  );

  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      <RichTextEditor
        $isRtl={isRtl}
        placeholder={placeholder || `${t('type')} ...`}
        value={value}
        onChange={handleChange}
        autoFocus={autoFocus}
        editorClassName={className}
      />
      {maxLength && (
        <MaxLengthLabel $hasExceededLimit={visibleLength > maxLength}>{`${visibleLength}/${maxLength}`}</MaxLengthLabel>
      )}
      {showLimitEditAdminsToggle && <EditableByAdmins />}
    </Wrapper>
  );
};
export default DescriptionFieldForm;
